import { Stack, Text } from "@chakra-ui/react";
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";
import RTable from "../../RTable";
import RTd from "../../RTable/RTd";
import RTr from "../../RTable/RTr";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Invoice").Invoice} invoice
 *
 * @param {Props} props
 */
function InvoiceDetails({ invoice }) {
  const intl = useIntl();

  return (
    <Stack spacing="1rem">
      <RTable
        columns={[
          { title: intl.formatMessage({ defaultMessage: "Nom" }) },
          {
            title: intl.formatMessage({ defaultMessage: "Tarif" }),
            textAlign: "right",
          },
        ]}>
        {invoice.services?.map((service) => (
          <RTr key={service.id}>
            <RTd>{service.name}</RTd>

            <RTd>
              <Text>
                <FormattedNumber
                  value={service.amount_tax_inc}
                  style="currency"
                  currency="EUR"
                />
              </Text>
            </RTd>
          </RTr>
        ))}
      </RTable>

      {invoice.pending_paid_amount > 0 && (
        <Text textAlign="right">
          <FormattedMessage
            defaultMessage="Déjà payé : {price}"
            values={{
              price: intl.formatNumber(invoice.pending_paid_amount, {
                style: "currency",
                currency: "EUR",
              }),
            }}
          />
        </Text>
      )}

      <Text
        fontSize="1.25rem"
        fontWeight={500}
        lineHeight="1.75rem"
        textAlign="right">
        <FormattedMessage
          defaultMessage="Total à payer : <span>{price}</span>"
          values={{
            price: intl.formatNumber(invoice.pending_due_amount, {
              style: "currency",
              currency: "EUR",
            }),
            span: (chunks) => (
              <Text as="span" color="brandPrimary.500">
                {chunks}
              </Text>
            ),
          }}
        />
      </Text>
    </Stack>
  );
}

export default InvoiceDetails;
